import { render, staticRenderFns } from "./LatestUsagePanel.vue?vue&type=template&id=4a32d5c1"
import script from "./LatestUsagePanel.vue?vue&type=script&lang=js"
export * from "./LatestUsagePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports